import React from "react";
import SidebarMenuBlocks from "../components/navigation/SidebarMenuBlocks";

const DefaultSidebar = ({ isMenuOpen, setIsMenuOpen }) => {
  const sidebarMenu = [
    {
      _id: "1",
      menuTitle: "Statistics & Analytics",
      menuData: [
        {
          _id: "1-1",
          menuLabel: "Dashboard",
          menuLink: "/dashboard",
          menuIcon: "fa-grid-2",
          menuIconColor: "text-rose-500",
        },
        {
          _id: "1-2",
          menuLabel: "Admins",
          menuLink: "/admins",
          menuIcon: "fa-user-crown",
          menuIconColor: "text-amber-500",
        },
        {
          _id: "1-3",
          menuLabel: "Users",
          menuLink: "/users",
          menuIcon: "fa-user",
          menuIconColor: "text-sky-500",
        },
        {
          _id: "1-4",
          menuLabel: "Employees",
          menuLink: "/employees",
          menuIcon: "fa-user",
          menuIconColor: "text-sky-500",
        },
      ],
    },
    {
      _id: "2",
      menuTitle: "Services & Categories",
      menuData: [
        {
          _id: "2-2",
          menuLabel: "Categories",
          menuLink: "/categories",
          menuIcon: "fa-grip",
          menuIconColor: "text-violet-500",
        },
        {
          _id: "3-3",
          menuLabel: "Services",
          menuLink: "/services",
          menuIcon: "fa-screwdriver-wrench",
          menuIconColor: "text-pink-500",
        },
        // {_id:'2-4',menuLabel:'Orders', menuLink:'/orders', menuIcon:'fa-box-circle-check', menuIconColor:'text-orange-500' },
      ],
    },
    {
      _id: "3",
      menuTitle: "Content Management",
      menuData: [
        {
          _id: "3-1",
          menuLabel: "Pages",
          menuLink: "/pages",
          menuIcon: "fa-memo-circle-info",
          menuIconColor: "text-cyan-500",
        },
        {
          _id: "3-2",
          menuLabel: "Banners",
          menuLink: "/banners",
          menuIcon: "fa-rectangle-history",
          menuIconColor: "text-yellow-500",
        },
        {
          _id: "3-3",
          menuLabel: "FAQs",
          menuLink: "/faq",
          menuIcon: "fa-circle-question",
          menuIconColor: "text-rose-500",
        },
        // {_id:'3-4',menuLabel:'Blogs', menuLink:'/blogs', menuIcon:'fa-newspaper', menuIconColor:'text-emerald-500' },
        {
          _id: "3-5",
          menuLabel: "Site Settings",
          menuLink: "/site-settings",
          menuIcon: "fa-gear",
          menuIconColor: "text-amber-500",
        },
      ],
    },
  ];

  return (
    <>
      <div className="relative w-full bg-slate-900 divide-y divide-slate-800">
        <div
          className={
            "relative flex items-center gap-4 h-16 transition-all duration-100 " +
            (isMenuOpen ? "px-3" : "px-4")
          }
        >
          <div className="w-10 h-10 min-w-[40px]">
            <img
              className="w-full h-full object-contain"
              src={"./logo.png"}
              alt={"Logo"}
            />
          </div>
          {!isMenuOpen && (
            <div className="w-full">
              <div className="text-lg text-white font-bold leading-tight">
                Symlink
              </div>
              <div className="text-xs text-white/50 leading-tight">
                Technologies LLP
              </div>
            </div>
          )}
        </div>
        <div
          className={
            "relative overflow-auto scroll-smooth scrollbar scrollbar-1 h-[calc(100vh-4rem)] transition-all duration-100 " +
            (isMenuOpen ? "divide-y divide-slate-800" : "")
          }
        >
          {sidebarMenu.map((item) => (
            <SidebarMenuBlocks
              key={item._id}
              menuTitle={item.menuTitle}
              menuData={item.menuData}
              isMenuOpen={isMenuOpen}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default DefaultSidebar;
